import { registerLocaleData } from "@angular/common"
import {provideHttpClient, withInterceptors} from "@angular/common/http"
import localeFr from "@angular/common/locales/fr"
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from "@angular/core"
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from "@angular/router"

import { fr as primeNGLocalFr } from "primelocale/fr.json"
import { ConfirmationService, MessageService } from "primeng/api"
import { providePrimeNG } from "primeng/config"
import { DialogService } from "primeng/dynamicdialog"

import { LgkLogService } from "@logick/common/logger"
import {apiAuthInterceptor, provideApi} from "@logick/core-api"
import { provideNavigation } from "@logick/ui/config"
import { LgkDialogManager } from "@logick/ui/dialog"
import { LogickAuraSlateTheme } from "@logick/ui-themes/presets/logick-aura-slate"

import { maintenanceInterceptor } from "@/core/maintenance"
import { provideErrorHandling } from "@/core/providers"
import { environment } from "@/environment"
import { AppDialogManager } from "@/shared/services/app-dialog-manager.service"
import { APP_MENU } from "./app.menu"
import { routes } from "./app.routes"

registerLocaleData(localeFr, "fr")
LgkLogService.configure(environment.LOG_LEVEL)

export const appConfig: ApplicationConfig = {
  providers: [

    provideZoneChangeDetection({ eventCoalescing: true }),
    providePrimeNG({
      translation: primeNGLocalFr,
      theme: LogickAuraSlateTheme
    }),
    { provide: LOCALE_ID, useValue: "fr-FR" },
    MessageService,
    ConfirmationService,
    DialogService,
    { provide: LgkDialogManager, useClass: AppDialogManager },
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ anchorScrolling: "enabled", scrollPositionRestoration: "enabled" })
    ),
    provideNavigation(APP_MENU),
    provideErrorHandling(),
    provideHttpClient(withInterceptors([apiAuthInterceptor, maintenanceInterceptor])),
    provideApi(environment.api)

  ]
}
